import React from 'react'
import PropTypes from 'prop-types'
import { Button, BUTTON_VARIATIONS } from '@yoti/ui-kit-components-react/button'

import './BackButton.scss'

const BackButton = ({ goBack, fullWidth, children }) => (
  <div className="back-button">
    <Button variation={BUTTON_VARIATIONS.OUTLINE_STANDARD} fullWidth={fullWidth} onClick={goBack}>
      { children }
    </Button>
  </div>
)

BackButton.propTypes = {
  goBack: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool.isRequired,
  children: PropTypes.objectOf(PropTypes.any).isRequired
}

export default BackButton
